module.exports = __webpack_public_path__ + "img/result-img-02@2x.6dd4eef2.png";